import { useQuery } from '@tanstack/react-query';
import { BidvBankTransferService } from 'services/openapi';

import { BidvBankTransferServiceKeys } from './constants';

export type BidvBankTransferWhitelistEntity = {
  statusCode: number;
  message: string[];
  whitelist: string[];
};

export const useGetBidvBankTransferWhitelistQuery = (
  enabled: boolean = true,
  compId?: string,
) => {
  const queryKey = [
    BidvBankTransferServiceKeys.GET_BANK_TRANSFER_WHITELIST,
    compId,
  ];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<BidvBankTransferWhitelistEntity, Error>({
    queryKey,
    queryFn: () =>
      BidvBankTransferService.bidvBankTransferControllerGetWhitelist(compId),
    retry: 0,
    refetchOnWindowFocus: false,
    enabled,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data,
    isError,
    queryKey,
    refetch,
  };
};
